module.exports = __webpack_public_path__ + "static/media/europoly.fbae0ec3.png";